module.exports = __webpack_public_path__ + "img/185.ca78a3c3.jpg";